import { useMutation } from "@tanstack/react-query";
import markParked from "../../controllers/appointments/mark-parked";

const useMarkParkedMutation = () => {
  return useMutation(markParked, {});
};

export default useMarkParkedMutation;
